import { jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from "react";
import assert from "assert";
import { InlineField } from "../private/InlineField/InlineField.mjs";
import { RadioGroupContext, RadioItemContext } from "./RadioGroupContext.mjs";
const RadioItem = forwardRef((props, ref) => {
  const radioGroupContext = useContext(RadioGroupContext);
  const radioItemContext = useContext(RadioItemContext);
  assert(
    radioGroupContext !== null && radioItemContext !== null,
    "All `RadioItem` buttons must be within a `RadioGroup`."
  );
  assert(
    typeof props.value !== "undefined" && props.value !== "",
    "All `RadioItem` buttons must have an associated `value`"
  );
  const checked = radioGroupContext.value === props.value;
  const isFirstRadioWithNoCheckedValueInGroup = radioItemContext === 0 && !Boolean(radioGroupContext.value);
  const tababble = checked || isFirstRadioWithNoCheckedValueInGroup;
  return /* @__PURE__ */ jsx(
    InlineField,
    {
      ...props,
      id: `${radioGroupContext.id}_${radioItemContext}`,
      name: radioGroupContext.name,
      checked,
      onChange: radioGroupContext.onChange,
      tone: radioGroupContext.tone === "critical" || radioGroupContext.tone === "neutral" ? radioGroupContext.tone : void 0,
      size: radioGroupContext.size,
      disabled: radioGroupContext.disabled || props.disabled,
      "aria-describedby": radioGroupContext["aria-describedby"],
      tabIndex: tababble ? 0 : -1,
      type: "radio",
      message: null,
      reserveMessageSpace: false,
      required: void 0,
      ref,
      children: props.children
    }
  );
});
RadioItem.displayName = "RadioItem";
export {
  RadioItem
};
